<template>
  <div class="largelogin">

    <div class="panelheader border-blue">
      <div class="booker-title">{{title}}</div>
    </div>

    <div class="body">

      <div v-if="showLogin">
        <loginform></loginform>
        <el-button type="primary" @click="changeToRegister">Register</el-button>
      </div>
      <div v-else>
        <registerform
          @login="changeToLogin">
        </registerform>

      </div>

    </div>

  </div>
</template>

<script>
import loginForm from '../LoginForm'
import registerForm from '../RegisterForm'

export default {
  name: 'largeLogin',
  data(){
    return {
      showLogin: false,
    }
  },
  methods: {
    changeToLogin() {
      this.showLogin = true;
    },
    changeToRegister() {
      this.showLogin = false;
    },
  },
  computed: {
    title: function(){
      return this.showLogin ? 'Login' : 'Register';
    }
  },
  components: {
    'loginform' : loginForm,
    'registerform': registerForm
  }
}
</script>

<style>

.largelogin {
  background: white;
}

.largelogin > .body {
  margin: 15px 25%;
}

</style>



// WEBPACK FOOTER //
// LargeLogin.vue?85f68afe